module.exports = __webpack_public_path__ + "media/images/emblems/Ipsach-coat_of_arms-e26d440770106f2791484f18d653027b.svg";